// 共用的參數
// 與 commonVariables 不同的是：
// commonParameters 是放置一些制式的參數，涵蓋整個專案的參數，通常為一串數字、字串。
// commonVaraiabls 則是放置常用的變數，或是與 API response 值所對應的規則

// header 的活動列表顯示數量的最大值，目前沒用到
export const eventListMaximun = 50;

// 各欄位的最大字數限制
export const inputMaximunLength = 50;

export const chartTitleFontSize = 18;

// header 在 576px 以下會變成 antd drawer 的形式
export const headerDrawerWidth = '70%';

// RWD breakpoint
export const doubleLargeDeviceWidth = 1920;
export const largeDeviceWidth = 1280;
export const medium1024DeviceWidth = 1024;
export const mediumDeviceWidth = 992;
export const medium745DeviceWidth = 745;
export const smallDeviceWidth = 576;

// 名單列表欄位的固定的 order by
export const idOrderByOfList = 0;
export const nameOrderByOfList = 1;
export const emailOrderByOfList = 2;
export const phoneOrderByOfList = 3;
// 名單預設欄位數
export const NUMBER_OF_DEFAULT_PARTICIPANT_LIST_COLUMNS = 4;
// 名單可新增欄位數(不包括系統預設欄位)
export const NUMBER_OF_CUSTOMIZE_PARTICIPANT_LIST_COLUMNS = 16;
// 名單最大欄位數(預設欄位數 + 可新增欄位數)
export const NUMBER_OF_MAXIMUM_PARTICIPANT_LIST_COLUMNS =
  NUMBER_OF_DEFAULT_PARTICIPANT_LIST_COLUMNS + NUMBER_OF_CUSTOMIZE_PARTICIPANT_LIST_COLUMNS;

// 初始的新手導覽步驟為 步驟二
export const initialTutorialActiveKey = '2';

// header height
export const HEADER_HEIGHT_LARGE = 60;
export const HEADER_HEIGHT_MEDIUM = 50;
export const HEADER_HEIGHT_SMALL = 40;

export const EVENT_HEADER_HEIGHT = 60;
export const EVENT_HEADER_HEIGHT_SMALL = 40;

export const antdWarningAlertAbsoluteTop = '45';

// ---------- API return message 相關 ----------
export const POINTS_CANNOT_BE_NEGATIVE_403 = 'Points cannot be negative.';

// ---------- 表單相關 ------------
export const shortTextQuestion = 'shortText';
export const singleChoiceQuestion = 'singleChoice';
export const multipleChoicesQuestion = 'multipleChoices';
export const ratingQuestion = 'rating';
export const dropdownQuestion = 'dropdown';
export const htmlQuestion = 'htmlQuestion';
export const pageNavigationQuestion = 'pageNavigation';
export const OTHER_CHOICE_VALUE = 'OTHER_CHOICE_VALUE';
export const OTHER_CHOICE_ID = 0;
export const OTHER_CHOICE_NAME = 'other';

// ---------- support language ---------
export const EN_US = 'en-US';

// ------------- App width ----------------
export const PHONE_DEVICE_WIDTH = '576px';
export const WHOLE_DEVICE_WDITH = '100%';

//  ---------- 來賓專屬頁面相關 ------------
export const indexPageMenuTypes = {
  eventInfo: 'eventInfo',
  surveyForm: 'surveyForm',
  externalUri: 'externalUri',
  booth: 'booth',
};

// --------- 系統相關 ---------
// 目前最新版號
export const systemPresentVersion = '1.18.0';

// 總時區表。資料來源: https://timezonedb.com/time-zones
export const timezoneList = {
  data: [
    {
      'Country Code': 'AF',
      'Country Name': 'Afghanistan',
      'Time Zone': 'Asia/Kabul',
      'GMT Offset': 'UTC +04:30',
    },
    {
      'Country Code': 'AL',
      'Country Name': 'Albania',
      'Time Zone': 'Europe/Tirane',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'DZ',
      'Country Name': 'Algeria',
      'Time Zone': 'Africa/Algiers',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'AS',
      'Country Name': 'American Samoa',
      'Time Zone': 'Pacific/Pago_Pago',
      'GMT Offset': 'UTC -11:00',
    },
    {
      'Country Code': 'AD',
      'Country Name': 'Andorra',
      'Time Zone': 'Europe/Andorra',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'AO',
      'Country Name': 'Angola',
      'Time Zone': 'Africa/Luanda',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'AI',
      'Country Name': 'Anguilla',
      'Time Zone': 'America/Anguilla',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'AQ',
      'Country Name': 'Antarctica',
      'Time Zone': 'Antarctica/Casey',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'AQ',
      'Country Name': 'Antarctica',
      'Time Zone': 'Antarctica/Davis',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'AQ',
      'Country Name': 'Antarctica',
      'Time Zone': 'Antarctica/DumontDUrville',
      'GMT Offset': 'UTC +10:00',
    },
    {
      'Country Code': 'AQ',
      'Country Name': 'Antarctica',
      'Time Zone': 'Antarctica/Mawson',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'AQ',
      'Country Name': 'Antarctica',
      'Time Zone': 'Antarctica/McMurdo',
      'GMT Offset': 'UTC +13:00',
    },
    {
      'Country Code': 'AQ',
      'Country Name': 'Antarctica',
      'Time Zone': 'Antarctica/Palmer',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AQ',
      'Country Name': 'Antarctica',
      'Time Zone': 'Antarctica/Rothera',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AQ',
      'Country Name': 'Antarctica',
      'Time Zone': 'Antarctica/Syowa',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'AQ',
      'Country Name': 'Antarctica',
      'Time Zone': 'Antarctica/Troll',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'AQ',
      'Country Name': 'Antarctica',
      'Time Zone': 'Antarctica/Vostok',
      'GMT Offset': 'UTC +06:00',
    },
    {
      'Country Code': 'AG',
      'Country Name': 'Antigua and Barbuda',
      'Time Zone': 'America/Antigua',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'AR',
      'Country Name': 'Argentina',
      'Time Zone': 'America/Argentina/Buenos_Aires',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AR',
      'Country Name': 'Argentina',
      'Time Zone': 'America/Argentina/Catamarca',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AR',
      'Country Name': 'Argentina',
      'Time Zone': 'America/Argentina/Cordoba',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AR',
      'Country Name': 'Argentina',
      'Time Zone': 'America/Argentina/Jujuy',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AR',
      'Country Name': 'Argentina',
      'Time Zone': 'America/Argentina/La_Rioja',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AR',
      'Country Name': 'Argentina',
      'Time Zone': 'America/Argentina/Mendoza',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AR',
      'Country Name': 'Argentina',
      'Time Zone': 'America/Argentina/Rio_Gallegos',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AR',
      'Country Name': 'Argentina',
      'Time Zone': 'America/Argentina/Salta',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AR',
      'Country Name': 'Argentina',
      'Time Zone': 'America/Argentina/San_Juan',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AR',
      'Country Name': 'Argentina',
      'Time Zone': 'America/Argentina/San_Luis',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AR',
      'Country Name': 'Argentina',
      'Time Zone': 'America/Argentina/Tucuman',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AR',
      'Country Name': 'Argentina',
      'Time Zone': 'America/Argentina/Ushuaia',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'AM',
      'Country Name': 'Armenia',
      'Time Zone': 'Asia/Yerevan',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'AW',
      'Country Name': 'Aruba',
      'Time Zone': 'America/Aruba',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Antarctica/Macquarie',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Australia/Adelaide',
      'GMT Offset': 'UTC +10:30',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Australia/Brisbane',
      'GMT Offset': 'UTC +10:00',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Australia/Broken_Hill',
      'GMT Offset': 'UTC +10:30',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Australia/Currie',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Australia/Darwin',
      'GMT Offset': 'UTC +09:30',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Australia/Eucla',
      'GMT Offset': 'UTC +08:45',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Australia/Hobart',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Australia/Lindeman',
      'GMT Offset': 'UTC +10:00',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Australia/Lord_Howe',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Australia/Melbourne',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Australia/Perth',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'AU',
      'Country Name': 'Australia',
      'Time Zone': 'Australia/Sydney',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'AT',
      'Country Name': 'Austria',
      'Time Zone': 'Europe/Vienna',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'AZ',
      'Country Name': 'Azerbaijan',
      'Time Zone': 'Asia/Baku',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'BS',
      'Country Name': 'Bahamas',
      'Time Zone': 'America/Nassau',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'BH',
      'Country Name': 'Bahrain',
      'Time Zone': 'Asia/Bahrain',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'BD',
      'Country Name': 'Bangladesh',
      'Time Zone': 'Asia/Dhaka',
      'GMT Offset': 'UTC +06:00',
    },
    {
      'Country Code': 'BB',
      'Country Name': 'Barbados',
      'Time Zone': 'America/Barbados',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'BY',
      'Country Name': 'Belarus',
      'Time Zone': 'Europe/Minsk',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'BE',
      'Country Name': 'Belgium',
      'Time Zone': 'Europe/Brussels',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'BZ',
      'Country Name': 'Belize',
      'Time Zone': 'America/Belize',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'BJ',
      'Country Name': 'Benin',
      'Time Zone': 'Africa/Porto-Novo',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'BM',
      'Country Name': 'Bermuda',
      'Time Zone': 'Atlantic/Bermuda',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'BT',
      'Country Name': 'Bhutan',
      'Time Zone': 'Asia/Thimphu',
      'GMT Offset': 'UTC +06:00',
    },
    {
      'Country Code': 'BO',
      'Country Name': 'Bolivia, Plurinational State of',
      'Time Zone': 'America/La_Paz',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'BQ',
      'Country Name': 'Bonaire, Sint Eustatius and Saba',
      'Time Zone': 'America/Kralendijk',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'BA',
      'Country Name': 'Bosnia and Herzegovina',
      'Time Zone': 'Europe/Sarajevo',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'BW',
      'Country Name': 'Botswana',
      'Time Zone': 'Africa/Gaborone',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Araguaina',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Bahia',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Belem',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Boa_Vista',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Campo_Grande',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Cuiaba',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Eirunepe',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Fortaleza',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Maceio',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Manaus',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Noronha',
      'GMT Offset': 'UTC -02:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Porto_Velho',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Recife',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Rio_Branco',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Santarem',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'BR',
      'Country Name': 'Brazil',
      'Time Zone': 'America/Sao_Paulo',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'IO',
      'Country Name': 'British Indian Ocean Territory',
      'Time Zone': 'Indian/Chagos',
      'GMT Offset': 'UTC +06:00',
    },
    {
      'Country Code': 'BN',
      'Country Name': 'Brunei Darussalam',
      'Time Zone': 'Asia/Brunei',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'BG',
      'Country Name': 'Bulgaria',
      'Time Zone': 'Europe/Sofia',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'BF',
      'Country Name': 'Burkina Faso',
      'Time Zone': 'Africa/Ouagadougou',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'BI',
      'Country Name': 'Burundi',
      'Time Zone': 'Africa/Bujumbura',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'KH',
      'Country Name': 'Cambodia',
      'Time Zone': 'Asia/Phnom_Penh',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'CM',
      'Country Name': 'Cameroon',
      'Time Zone': 'Africa/Douala',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Atikokan',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Blanc-Sablon',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Cambridge_Bay',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Creston',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Dawson',
      'GMT Offset': 'UTC -08:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Dawson_Creek',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Edmonton',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Fort_Nelson',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Glace_Bay',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Goose_Bay',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Halifax',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Inuvik',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Iqaluit',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Moncton',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Nipigon',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Pangnirtung',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Rainy_River',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Rankin_Inlet',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Regina',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Resolute',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/St_Johns',
      'GMT Offset': 'UTC -03:30',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Swift_Current',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Thunder_Bay',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Toronto',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Vancouver',
      'GMT Offset': 'UTC -08:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Whitehorse',
      'GMT Offset': 'UTC -08:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Winnipeg',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'CA',
      'Country Name': 'Canada',
      'Time Zone': 'America/Yellowknife',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'CV',
      'Country Name': 'Cape Verde',
      'Time Zone': 'Atlantic/Cape_Verde',
      'GMT Offset': 'UTC -01:00',
    },
    {
      'Country Code': 'KY',
      'Country Name': 'Cayman Islands',
      'Time Zone': 'America/Cayman',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'CF',
      'Country Name': 'Central African Republic',
      'Time Zone': 'Africa/Bangui',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'TD',
      'Country Name': 'Chad',
      'Time Zone': 'Africa/Ndjamena',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'CL',
      'Country Name': 'Chile',
      'Time Zone': 'America/Punta_Arenas',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'CL',
      'Country Name': 'Chile',
      'Time Zone': 'America/Santiago',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'CL',
      'Country Name': 'Chile',
      'Time Zone': 'Pacific/Easter',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'CN',
      'Country Name': 'China',
      'Time Zone': 'Asia/Shanghai',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'CN',
      'Country Name': 'China',
      'Time Zone': 'Asia/Urumqi',
      'GMT Offset': 'UTC +06:00',
    },
    {
      'Country Code': 'CX',
      'Country Name': 'Christmas Island',
      'Time Zone': 'Indian/Christmas',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'CC',
      'Country Name': 'Cocos (Keeling) Islands',
      'Time Zone': 'Indian/Cocos',
      'GMT Offset': 'UTC +06:30',
    },
    {
      'Country Code': 'CO',
      'Country Name': 'Colombia',
      'Time Zone': 'America/Bogota',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'KM',
      'Country Name': 'Comoros',
      'Time Zone': 'Indian/Comoro',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'CG',
      'Country Name': 'Congo',
      'Time Zone': 'Africa/Brazzaville',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'CD',
      'Country Name': 'Congo, the Democratic Republic of the',
      'Time Zone': 'Africa/Kinshasa',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'CD',
      'Country Name': 'Congo, the Democratic Republic of the',
      'Time Zone': 'Africa/Lubumbashi',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'CK',
      'Country Name': 'Cook Islands',
      'Time Zone': 'Pacific/Rarotonga',
      'GMT Offset': 'UTC -10:00',
    },
    {
      'Country Code': 'CR',
      'Country Name': 'Costa Rica',
      'Time Zone': 'America/Costa_Rica',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'HR',
      'Country Name': 'Croatia',
      'Time Zone': 'Europe/Zagreb',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'CU',
      'Country Name': 'Cuba',
      'Time Zone': 'America/Havana',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'CW',
      'Country Name': 'Curaçao',
      'Time Zone': 'America/Curacao',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'CY',
      'Country Name': 'Cyprus',
      'Time Zone': 'Asia/Famagusta',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'CY',
      'Country Name': 'Cyprus',
      'Time Zone': 'Asia/Nicosia',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'CZ',
      'Country Name': 'Czech Republic',
      'Time Zone': 'Europe/Prague',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'CI',
      'Country Name': "Côte d'Ivoire",
      'Time Zone': 'Africa/Abidjan',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'DK',
      'Country Name': 'Denmark',
      'Time Zone': 'Europe/Copenhagen',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'DJ',
      'Country Name': 'Djibouti',
      'Time Zone': 'Africa/Djibouti',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'DM',
      'Country Name': 'Dominica',
      'Time Zone': 'America/Dominica',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'DO',
      'Country Name': 'Dominican Republic',
      'Time Zone': 'America/Santo_Domingo',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'EC',
      'Country Name': 'Ecuador',
      'Time Zone': 'America/Guayaquil',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'EC',
      'Country Name': 'Ecuador',
      'Time Zone': 'Pacific/Galapagos',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'EG',
      'Country Name': 'Egypt',
      'Time Zone': 'Africa/Cairo',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'SV',
      'Country Name': 'El Salvador',
      'Time Zone': 'America/El_Salvador',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'GQ',
      'Country Name': 'Equatorial Guinea',
      'Time Zone': 'Africa/Malabo',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'ER',
      'Country Name': 'Eritrea',
      'Time Zone': 'Africa/Asmara',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'EE',
      'Country Name': 'Estonia',
      'Time Zone': 'Europe/Tallinn',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'ET',
      'Country Name': 'Ethiopia',
      'Time Zone': 'Africa/Addis_Ababa',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'FK',
      'Country Name': 'Falkland Islands (Malvinas)',
      'Time Zone': 'Atlantic/Stanley',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'FO',
      'Country Name': 'Faroe Islands',
      'Time Zone': 'Atlantic/Faroe',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'FJ',
      'Country Name': 'Fiji',
      'Time Zone': 'Pacific/Fiji',
      'GMT Offset': 'UTC +12:00',
    },
    {
      'Country Code': 'FI',
      'Country Name': 'Finland',
      'Time Zone': 'Europe/Helsinki',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'FR',
      'Country Name': 'France',
      'Time Zone': 'Europe/Paris',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'GF',
      'Country Name': 'French Guiana',
      'Time Zone': 'America/Cayenne',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'PF',
      'Country Name': 'French Polynesia',
      'Time Zone': 'Pacific/Gambier',
      'GMT Offset': 'UTC -09:00',
    },
    {
      'Country Code': 'PF',
      'Country Name': 'French Polynesia',
      'Time Zone': 'Pacific/Marquesas',
      'GMT Offset': 'UTC -09:30',
    },
    {
      'Country Code': 'PF',
      'Country Name': 'French Polynesia',
      'Time Zone': 'Pacific/Tahiti',
      'GMT Offset': 'UTC -10:00',
    },
    {
      'Country Code': 'TF',
      'Country Name': 'French Southern Territories',
      'Time Zone': 'Indian/Kerguelen',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'GA',
      'Country Name': 'Gabon',
      'Time Zone': 'Africa/Libreville',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'GM',
      'Country Name': 'Gambia',
      'Time Zone': 'Africa/Banjul',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'GE',
      'Country Name': 'Georgia',
      'Time Zone': 'Asia/Tbilisi',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'DE',
      'Country Name': 'Germany',
      'Time Zone': 'Europe/Berlin',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'DE',
      'Country Name': 'Germany',
      'Time Zone': 'Europe/Busingen',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'GH',
      'Country Name': 'Ghana',
      'Time Zone': 'Africa/Accra',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'GI',
      'Country Name': 'Gibraltar',
      'Time Zone': 'Europe/Gibraltar',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'GR',
      'Country Name': 'Greece',
      'Time Zone': 'Europe/Athens',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'GL',
      'Country Name': 'Greenland',
      'Time Zone': 'America/Danmarkshavn',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'GL',
      'Country Name': 'Greenland',
      'Time Zone': 'America/Godthab',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'GL',
      'Country Name': 'Greenland',
      'Time Zone': 'America/Scoresbysund',
      'GMT Offset': 'UTC -01:00',
    },
    {
      'Country Code': 'GL',
      'Country Name': 'Greenland',
      'Time Zone': 'America/Thule',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'GD',
      'Country Name': 'Grenada',
      'Time Zone': 'America/Grenada',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'GP',
      'Country Name': 'Guadeloupe',
      'Time Zone': 'America/Guadeloupe',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'GU',
      'Country Name': 'Guam',
      'Time Zone': 'Pacific/Guam',
      'GMT Offset': 'UTC +10:00',
    },
    {
      'Country Code': 'GT',
      'Country Name': 'Guatemala',
      'Time Zone': 'America/Guatemala',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'GG',
      'Country Name': 'Guernsey',
      'Time Zone': 'Europe/Guernsey',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'GN',
      'Country Name': 'Guinea',
      'Time Zone': 'Africa/Conakry',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'GW',
      'Country Name': 'Guinea-Bissau',
      'Time Zone': 'Africa/Bissau',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'GY',
      'Country Name': 'Guyana',
      'Time Zone': 'America/Guyana',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'HT',
      'Country Name': 'Haiti',
      'Time Zone': 'America/Port-au-Prince',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'VA',
      'Country Name': 'Holy See (Vatican City State)',
      'Time Zone': 'Europe/Vatican',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'HN',
      'Country Name': 'Honduras',
      'Time Zone': 'America/Tegucigalpa',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'HK',
      'Country Name': 'Hong Kong',
      'Time Zone': 'Asia/Hong_Kong',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'HU',
      'Country Name': 'Hungary',
      'Time Zone': 'Europe/Budapest',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'IS',
      'Country Name': 'Iceland',
      'Time Zone': 'Atlantic/Reykjavik',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'IN',
      'Country Name': 'India',
      'Time Zone': 'Asia/Kolkata',
      'GMT Offset': 'UTC +05:30',
    },
    {
      'Country Code': 'ID',
      'Country Name': 'Indonesia',
      'Time Zone': 'Asia/Jakarta',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'ID',
      'Country Name': 'Indonesia',
      'Time Zone': 'Asia/Jayapura',
      'GMT Offset': 'UTC +09:00',
    },
    {
      'Country Code': 'ID',
      'Country Name': 'Indonesia',
      'Time Zone': 'Asia/Makassar',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'ID',
      'Country Name': 'Indonesia',
      'Time Zone': 'Asia/Pontianak',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'IR',
      'Country Name': 'Iran, Islamic Republic of',
      'Time Zone': 'Asia/Tehran',
      'GMT Offset': 'UTC +03:30',
    },
    {
      'Country Code': 'IQ',
      'Country Name': 'Iraq',
      'Time Zone': 'Asia/Baghdad',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'IE',
      'Country Name': 'Ireland',
      'Time Zone': 'Europe/Dublin',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'IM',
      'Country Name': 'Isle of Man',
      'Time Zone': 'Europe/Isle_of_Man',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'IL',
      'Country Name': 'Israel',
      'Time Zone': 'Asia/Jerusalem',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'IT',
      'Country Name': 'Italy',
      'Time Zone': 'Europe/Rome',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'JM',
      'Country Name': 'Jamaica',
      'Time Zone': 'America/Jamaica',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'JP',
      'Country Name': 'Japan',
      'Time Zone': 'Asia/Tokyo',
      'GMT Offset': 'UTC +09:00',
    },
    {
      'Country Code': 'JE',
      'Country Name': 'Jersey',
      'Time Zone': 'Europe/Jersey',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'JO',
      'Country Name': 'Jordan',
      'Time Zone': 'Asia/Amman',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'KZ',
      'Country Name': 'Kazakhstan',
      'Time Zone': 'Asia/Almaty',
      'GMT Offset': 'UTC +06:00',
    },
    {
      'Country Code': 'KZ',
      'Country Name': 'Kazakhstan',
      'Time Zone': 'Asia/Aqtau',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'KZ',
      'Country Name': 'Kazakhstan',
      'Time Zone': 'Asia/Aqtobe',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'KZ',
      'Country Name': 'Kazakhstan',
      'Time Zone': 'Asia/Atyrau',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'KZ',
      'Country Name': 'Kazakhstan',
      'Time Zone': 'Asia/Oral',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'KZ',
      'Country Name': 'Kazakhstan',
      'Time Zone': 'Asia/Qostanay',
      'GMT Offset': 'UTC +06:00',
    },
    {
      'Country Code': 'KZ',
      'Country Name': 'Kazakhstan',
      'Time Zone': 'Asia/Qyzylorda',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'KE',
      'Country Name': 'Kenya',
      'Time Zone': 'Africa/Nairobi',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'KI',
      'Country Name': 'Kiribati',
      'Time Zone': 'Pacific/Enderbury',
      'GMT Offset': 'UTC +13:00',
    },
    {
      'Country Code': 'KI',
      'Country Name': 'Kiribati',
      'Time Zone': 'Pacific/Kiritimati',
      'GMT Offset': 'UTC +14:00',
    },
    {
      'Country Code': 'KI',
      'Country Name': 'Kiribati',
      'Time Zone': 'Pacific/Tarawa',
      'GMT Offset': 'UTC +12:00',
    },
    {
      'Country Code': 'KP',
      'Country Name': "Korea, Democratic People's Republic of",
      'Time Zone': 'Asia/Pyongyang',
      'GMT Offset': 'UTC +09:00',
    },
    {
      'Country Code': 'KR',
      'Country Name': 'Korea, Republic of',
      'Time Zone': 'Asia/Seoul',
      'GMT Offset': 'UTC +09:00',
    },
    {
      'Country Code': 'KW',
      'Country Name': 'Kuwait',
      'Time Zone': 'Asia/Kuwait',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'KG',
      'Country Name': 'Kyrgyzstan',
      'Time Zone': 'Asia/Bishkek',
      'GMT Offset': 'UTC +06:00',
    },
    {
      'Country Code': 'LA',
      'Country Name': "Lao People's Democratic Republic",
      'Time Zone': 'Asia/Vientiane',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'LV',
      'Country Name': 'Latvia',
      'Time Zone': 'Europe/Riga',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'LB',
      'Country Name': 'Lebanon',
      'Time Zone': 'Asia/Beirut',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'LS',
      'Country Name': 'Lesotho',
      'Time Zone': 'Africa/Maseru',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'LR',
      'Country Name': 'Liberia',
      'Time Zone': 'Africa/Monrovia',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'LY',
      'Country Name': 'Libya',
      'Time Zone': 'Africa/Tripoli',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'LI',
      'Country Name': 'Liechtenstein',
      'Time Zone': 'Europe/Vaduz',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'LT',
      'Country Name': 'Lithuania',
      'Time Zone': 'Europe/Vilnius',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'LU',
      'Country Name': 'Luxembourg',
      'Time Zone': 'Europe/Luxembourg',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'MO',
      'Country Name': 'Macao',
      'Time Zone': 'Asia/Macau',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'MK',
      'Country Name': 'Macedonia, the Former Yugoslav Republic of',
      'Time Zone': 'Europe/Skopje',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'MG',
      'Country Name': 'Madagascar',
      'Time Zone': 'Indian/Antananarivo',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'MW',
      'Country Name': 'Malawi',
      'Time Zone': 'Africa/Blantyre',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'MY',
      'Country Name': 'Malaysia',
      'Time Zone': 'Asia/Kuala_Lumpur',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'MY',
      'Country Name': 'Malaysia',
      'Time Zone': 'Asia/Kuching',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'MV',
      'Country Name': 'Maldives',
      'Time Zone': 'Indian/Maldives',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'ML',
      'Country Name': 'Mali',
      'Time Zone': 'Africa/Bamako',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'MT',
      'Country Name': 'Malta',
      'Time Zone': 'Europe/Malta',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'MH',
      'Country Name': 'Marshall Islands',
      'Time Zone': 'Pacific/Kwajalein',
      'GMT Offset': 'UTC +12:00',
    },
    {
      'Country Code': 'MH',
      'Country Name': 'Marshall Islands',
      'Time Zone': 'Pacific/Majuro',
      'GMT Offset': 'UTC +12:00',
    },
    {
      'Country Code': 'MQ',
      'Country Name': 'Martinique',
      'Time Zone': 'America/Martinique',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'MR',
      'Country Name': 'Mauritania',
      'Time Zone': 'Africa/Nouakchott',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'MU',
      'Country Name': 'Mauritius',
      'Time Zone': 'Indian/Mauritius',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'YT',
      'Country Name': 'Mayotte',
      'Time Zone': 'Indian/Mayotte',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'MX',
      'Country Name': 'Mexico',
      'Time Zone': 'America/Bahia_Banderas',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'MX',
      'Country Name': 'Mexico',
      'Time Zone': 'America/Cancun',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'MX',
      'Country Name': 'Mexico',
      'Time Zone': 'America/Chihuahua',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'MX',
      'Country Name': 'Mexico',
      'Time Zone': 'America/Hermosillo',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'MX',
      'Country Name': 'Mexico',
      'Time Zone': 'America/Matamoros',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'MX',
      'Country Name': 'Mexico',
      'Time Zone': 'America/Mazatlan',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'MX',
      'Country Name': 'Mexico',
      'Time Zone': 'America/Merida',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'MX',
      'Country Name': 'Mexico',
      'Time Zone': 'America/Mexico_City',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'MX',
      'Country Name': 'Mexico',
      'Time Zone': 'America/Monterrey',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'MX',
      'Country Name': 'Mexico',
      'Time Zone': 'America/Ojinaga',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'MX',
      'Country Name': 'Mexico',
      'Time Zone': 'America/Tijuana',
      'GMT Offset': 'UTC -08:00',
    },
    {
      'Country Code': 'FM',
      'Country Name': 'Micronesia, Federated States of',
      'Time Zone': 'Pacific/Chuuk',
      'GMT Offset': 'UTC +10:00',
    },
    {
      'Country Code': 'FM',
      'Country Name': 'Micronesia, Federated States of',
      'Time Zone': 'Pacific/Kosrae',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'FM',
      'Country Name': 'Micronesia, Federated States of',
      'Time Zone': 'Pacific/Pohnpei',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'MD',
      'Country Name': 'Moldova, Republic of',
      'Time Zone': 'Europe/Chisinau',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'MC',
      'Country Name': 'Monaco',
      'Time Zone': 'Europe/Monaco',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'MN',
      'Country Name': 'Mongolia',
      'Time Zone': 'Asia/Choibalsan',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'MN',
      'Country Name': 'Mongolia',
      'Time Zone': 'Asia/Hovd',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'MN',
      'Country Name': 'Mongolia',
      'Time Zone': 'Asia/Ulaanbaatar',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'ME',
      'Country Name': 'Montenegro',
      'Time Zone': 'Europe/Podgorica',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'MS',
      'Country Name': 'Montserrat',
      'Time Zone': 'America/Montserrat',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'MA',
      'Country Name': 'Morocco',
      'Time Zone': 'Africa/Casablanca',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'MZ',
      'Country Name': 'Mozambique',
      'Time Zone': 'Africa/Maputo',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'MM',
      'Country Name': 'Myanmar',
      'Time Zone': 'Asia/Yangon',
      'GMT Offset': 'UTC +06:30',
    },
    {
      'Country Code': 'NA',
      'Country Name': 'Namibia',
      'Time Zone': 'Africa/Windhoek',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'NR',
      'Country Name': 'Nauru',
      'Time Zone': 'Pacific/Nauru',
      'GMT Offset': 'UTC +12:00',
    },
    {
      'Country Code': 'NP',
      'Country Name': 'Nepal',
      'Time Zone': 'Asia/Kathmandu',
      'GMT Offset': 'UTC +05:45',
    },
    {
      'Country Code': 'NL',
      'Country Name': 'Netherlands',
      'Time Zone': 'Europe/Amsterdam',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'NC',
      'Country Name': 'New Caledonia',
      'Time Zone': 'Pacific/Noumea',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'NZ',
      'Country Name': 'New Zealand',
      'Time Zone': 'Pacific/Auckland',
      'GMT Offset': 'UTC +13:00',
    },
    {
      'Country Code': 'NZ',
      'Country Name': 'New Zealand',
      'Time Zone': 'Pacific/Chatham',
      'GMT Offset': 'UTC +13:45',
    },
    {
      'Country Code': 'NI',
      'Country Name': 'Nicaragua',
      'Time Zone': 'America/Managua',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'NE',
      'Country Name': 'Niger',
      'Time Zone': 'Africa/Niamey',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'NG',
      'Country Name': 'Nigeria',
      'Time Zone': 'Africa/Lagos',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'NU',
      'Country Name': 'Niue',
      'Time Zone': 'Pacific/Niue',
      'GMT Offset': 'UTC -11:00',
    },
    {
      'Country Code': 'NF',
      'Country Name': 'Norfolk Island',
      'Time Zone': 'Pacific/Norfolk',
      'GMT Offset': 'UTC +12:00',
    },
    {
      'Country Code': 'MP',
      'Country Name': 'Northern Mariana Islands',
      'Time Zone': 'Pacific/Saipan',
      'GMT Offset': 'UTC +10:00',
    },
    {
      'Country Code': 'NO',
      'Country Name': 'Norway',
      'Time Zone': 'Europe/Oslo',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'OM',
      'Country Name': 'Oman',
      'Time Zone': 'Asia/Muscat',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'PK',
      'Country Name': 'Pakistan',
      'Time Zone': 'Asia/Karachi',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'PW',
      'Country Name': 'Palau',
      'Time Zone': 'Pacific/Palau',
      'GMT Offset': 'UTC +09:00',
    },
    {
      'Country Code': 'PS',
      'Country Name': 'Palestine, State of',
      'Time Zone': 'Asia/Gaza',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'PS',
      'Country Name': 'Palestine, State of',
      'Time Zone': 'Asia/Hebron',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'PA',
      'Country Name': 'Panama',
      'Time Zone': 'America/Panama',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'PG',
      'Country Name': 'Papua New Guinea',
      'Time Zone': 'Pacific/Bougainville',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'PG',
      'Country Name': 'Papua New Guinea',
      'Time Zone': 'Pacific/Port_Moresby',
      'GMT Offset': 'UTC +10:00',
    },
    {
      'Country Code': 'PY',
      'Country Name': 'Paraguay',
      'Time Zone': 'America/Asuncion',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'PE',
      'Country Name': 'Peru',
      'Time Zone': 'America/Lima',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'PH',
      'Country Name': 'Philippines',
      'Time Zone': 'Asia/Manila',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'PN',
      'Country Name': 'Pitcairn',
      'Time Zone': 'Pacific/Pitcairn',
      'GMT Offset': 'UTC -08:00',
    },
    {
      'Country Code': 'PL',
      'Country Name': 'Poland',
      'Time Zone': 'Europe/Warsaw',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'PT',
      'Country Name': 'Portugal',
      'Time Zone': 'Atlantic/Azores',
      'GMT Offset': 'UTC -01:00',
    },
    {
      'Country Code': 'PT',
      'Country Name': 'Portugal',
      'Time Zone': 'Atlantic/Madeira',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'PT',
      'Country Name': 'Portugal',
      'Time Zone': 'Europe/Lisbon',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'PR',
      'Country Name': 'Puerto Rico',
      'Time Zone': 'America/Puerto_Rico',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'QA',
      'Country Name': 'Qatar',
      'Time Zone': 'Asia/Qatar',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'RO',
      'Country Name': 'Romania',
      'Time Zone': 'Europe/Bucharest',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Anadyr',
      'GMT Offset': 'UTC +12:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Barnaul',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Chita',
      'GMT Offset': 'UTC +09:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Irkutsk',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Kamchatka',
      'GMT Offset': 'UTC +12:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Khandyga',
      'GMT Offset': 'UTC +09:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Krasnoyarsk',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Magadan',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Novokuznetsk',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Novosibirsk',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Omsk',
      'GMT Offset': 'UTC +06:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Sakhalin',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Srednekolymsk',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Tomsk',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Ust-Nera',
      'GMT Offset': 'UTC +10:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Vladivostok',
      'GMT Offset': 'UTC +10:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Yakutsk',
      'GMT Offset': 'UTC +09:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Asia/Yekaterinburg',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Europe/Astrakhan',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Europe/Kaliningrad',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Europe/Kirov',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Europe/Moscow',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Europe/Samara',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Europe/Saratov',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Europe/Ulyanovsk',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'RU',
      'Country Name': 'Russian Federation',
      'Time Zone': 'Europe/Volgograd',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'RW',
      'Country Name': 'Rwanda',
      'Time Zone': 'Africa/Kigali',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'RE',
      'Country Name': 'Réunion',
      'Time Zone': 'Indian/Reunion',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'BL',
      'Country Name': 'Saint Barthélemy',
      'Time Zone': 'America/St_Barthelemy',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'SH',
      'Country Name': 'Saint Helena, Ascension and Tristan da Cunha',
      'Time Zone': 'Atlantic/St_Helena',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'KN',
      'Country Name': 'Saint Kitts and Nevis',
      'Time Zone': 'America/St_Kitts',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'LC',
      'Country Name': 'Saint Lucia',
      'Time Zone': 'America/St_Lucia',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'MF',
      'Country Name': 'Saint Martin (French part)',
      'Time Zone': 'America/Marigot',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'PM',
      'Country Name': 'Saint Pierre and Miquelon',
      'Time Zone': 'America/Miquelon',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'VC',
      'Country Name': 'Saint Vincent and the Grenadines',
      'Time Zone': 'America/St_Vincent',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'WS',
      'Country Name': 'Samoa',
      'Time Zone': 'Pacific/Apia',
      'GMT Offset': 'UTC +14:00',
    },
    {
      'Country Code': 'SM',
      'Country Name': 'San Marino',
      'Time Zone': 'Europe/San_Marino',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'ST',
      'Country Name': 'Sao Tome and Principe',
      'Time Zone': 'Africa/Sao_Tome',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'SA',
      'Country Name': 'Saudi Arabia',
      'Time Zone': 'Asia/Riyadh',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'SN',
      'Country Name': 'Senegal',
      'Time Zone': 'Africa/Dakar',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'RS',
      'Country Name': 'Serbia',
      'Time Zone': 'Europe/Belgrade',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'SC',
      'Country Name': 'Seychelles',
      'Time Zone': 'Indian/Mahe',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'SL',
      'Country Name': 'Sierra Leone',
      'Time Zone': 'Africa/Freetown',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'SG',
      'Country Name': 'Singapore',
      'Time Zone': 'Asia/Singapore',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'SX',
      'Country Name': 'Sint Maarten (Dutch part)',
      'Time Zone': 'America/Lower_Princes',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'SK',
      'Country Name': 'Slovakia',
      'Time Zone': 'Europe/Bratislava',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'SI',
      'Country Name': 'Slovenia',
      'Time Zone': 'Europe/Ljubljana',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'SB',
      'Country Name': 'Solomon Islands',
      'Time Zone': 'Pacific/Guadalcanal',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'SO',
      'Country Name': 'Somalia',
      'Time Zone': 'Africa/Mogadishu',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'ZA',
      'Country Name': 'South Africa',
      'Time Zone': 'Africa/Johannesburg',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'GS',
      'Country Name': 'South Georgia and the South Sandwich Islands',
      'Time Zone': 'Atlantic/South_Georgia',
      'GMT Offset': 'UTC -02:00',
    },
    {
      'Country Code': 'SS',
      'Country Name': 'South Sudan',
      'Time Zone': 'Africa/Juba',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'ES',
      'Country Name': 'Spain',
      'Time Zone': 'Africa/Ceuta',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'ES',
      'Country Name': 'Spain',
      'Time Zone': 'Atlantic/Canary',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'ES',
      'Country Name': 'Spain',
      'Time Zone': 'Europe/Madrid',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'LK',
      'Country Name': 'Sri Lanka',
      'Time Zone': 'Asia/Colombo',
      'GMT Offset': 'UTC +05:30',
    },
    {
      'Country Code': 'SD',
      'Country Name': 'Sudan',
      'Time Zone': 'Africa/Khartoum',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'SR',
      'Country Name': 'Suriname',
      'Time Zone': 'America/Paramaribo',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'SJ',
      'Country Name': 'Svalbard and Jan Mayen',
      'Time Zone': 'Arctic/Longyearbyen',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'SZ',
      'Country Name': 'Swaziland',
      'Time Zone': 'Africa/Mbabane',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'SE',
      'Country Name': 'Sweden',
      'Time Zone': 'Europe/Stockholm',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'CH',
      'Country Name': 'Switzerland',
      'Time Zone': 'Europe/Zurich',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'SY',
      'Country Name': 'Syrian Arab Republic',
      'Time Zone': 'Asia/Damascus',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'TW',
      'Country Name': 'Taiwan, Province of China',
      'Time Zone': 'Asia/Taipei',
      'GMT Offset': 'UTC +08:00',
    },
    {
      'Country Code': 'TJ',
      'Country Name': 'Tajikistan',
      'Time Zone': 'Asia/Dushanbe',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'TZ',
      'Country Name': 'Tanzania, United Republic of',
      'Time Zone': 'Africa/Dar_es_Salaam',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'TH',
      'Country Name': 'Thailand',
      'Time Zone': 'Asia/Bangkok',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'TL',
      'Country Name': 'Timor-Leste',
      'Time Zone': 'Asia/Dili',
      'GMT Offset': 'UTC +09:00',
    },
    {
      'Country Code': 'TG',
      'Country Name': 'Togo',
      'Time Zone': 'Africa/Lome',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'TK',
      'Country Name': 'Tokelau',
      'Time Zone': 'Pacific/Fakaofo',
      'GMT Offset': 'UTC +13:00',
    },
    {
      'Country Code': 'TO',
      'Country Name': 'Tonga',
      'Time Zone': 'Pacific/Tongatapu',
      'GMT Offset': 'UTC +13:00',
    },
    {
      'Country Code': 'TT',
      'Country Name': 'Trinidad and Tobago',
      'Time Zone': 'America/Port_of_Spain',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'TN',
      'Country Name': 'Tunisia',
      'Time Zone': 'Africa/Tunis',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'TR',
      'Country Name': 'Turkey',
      'Time Zone': 'Europe/Istanbul',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'TM',
      'Country Name': 'Turkmenistan',
      'Time Zone': 'Asia/Ashgabat',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'TC',
      'Country Name': 'Turks and Caicos Islands',
      'Time Zone': 'America/Grand_Turk',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'TV',
      'Country Name': 'Tuvalu',
      'Time Zone': 'Pacific/Funafuti',
      'GMT Offset': 'UTC +12:00',
    },
    {
      'Country Code': 'UG',
      'Country Name': 'Uganda',
      'Time Zone': 'Africa/Kampala',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'UA',
      'Country Name': 'Ukraine',
      'Time Zone': 'Europe/Kiev',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'UA',
      'Country Name': 'Ukraine',
      'Time Zone': 'Europe/Simferopol',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'UA',
      'Country Name': 'Ukraine',
      'Time Zone': 'Europe/Uzhgorod',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'UA',
      'Country Name': 'Ukraine',
      'Time Zone': 'Europe/Zaporozhye',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'AE',
      'Country Name': 'United Arab Emirates',
      'Time Zone': 'Asia/Dubai',
      'GMT Offset': 'UTC +04:00',
    },
    {
      'Country Code': 'GB',
      'Country Name': 'United Kingdom',
      'Time Zone': 'Europe/London',
      'GMT Offset': 'UTC',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Adak',
      'GMT Offset': 'UTC -10:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Anchorage',
      'GMT Offset': 'UTC -09:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Boise',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Chicago',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Denver',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Detroit',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Indiana/Indianapolis',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Indiana/Knox',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Indiana/Marengo',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Indiana/Petersburg',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Indiana/Tell_City',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Indiana/Vevay',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Indiana/Vincennes',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Indiana/Winamac',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Juneau',
      'GMT Offset': 'UTC -09:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Kentucky/Louisville',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Kentucky/Monticello',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Los_Angeles',
      'GMT Offset': 'UTC -08:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Menominee',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Metlakatla',
      'GMT Offset': 'UTC -09:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/New_York',
      'GMT Offset': 'UTC -05:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Nome',
      'GMT Offset': 'UTC -09:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/North_Dakota/Beulah',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/North_Dakota/Center',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/North_Dakota/New_Salem',
      'GMT Offset': 'UTC -06:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Phoenix',
      'GMT Offset': 'UTC -07:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Sitka',
      'GMT Offset': 'UTC -09:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'America/Yakutat',
      'GMT Offset': 'UTC -09:00',
    },
    {
      'Country Code': 'US',
      'Country Name': 'United States',
      'Time Zone': 'Pacific/Honolulu',
      'GMT Offset': 'UTC -10:00',
    },
    {
      'Country Code': 'UM',
      'Country Name': 'United States Minor Outlying Islands',
      'Time Zone': 'Pacific/Midway',
      'GMT Offset': 'UTC -11:00',
    },
    {
      'Country Code': 'UM',
      'Country Name': 'United States Minor Outlying Islands',
      'Time Zone': 'Pacific/Wake',
      'GMT Offset': 'UTC +12:00',
    },
    {
      'Country Code': 'UY',
      'Country Name': 'Uruguay',
      'Time Zone': 'America/Montevideo',
      'GMT Offset': 'UTC -03:00',
    },
    {
      'Country Code': 'UZ',
      'Country Name': 'Uzbekistan',
      'Time Zone': 'Asia/Samarkand',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'UZ',
      'Country Name': 'Uzbekistan',
      'Time Zone': 'Asia/Tashkent',
      'GMT Offset': 'UTC +05:00',
    },
    {
      'Country Code': 'VU',
      'Country Name': 'Vanuatu',
      'Time Zone': 'Pacific/Efate',
      'GMT Offset': 'UTC +11:00',
    },
    {
      'Country Code': 'VE',
      'Country Name': 'Venezuela, Bolivarian Republic of',
      'Time Zone': 'America/Caracas',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'VN',
      'Country Name': 'Viet Nam',
      'Time Zone': 'Asia/Ho_Chi_Minh',
      'GMT Offset': 'UTC +07:00',
    },
    {
      'Country Code': 'VG',
      'Country Name': 'Virgin Islands, British',
      'Time Zone': 'America/Tortola',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'VI',
      'Country Name': 'Virgin Islands, U.S.',
      'Time Zone': 'America/St_Thomas',
      'GMT Offset': 'UTC -04:00',
    },
    {
      'Country Code': 'WF',
      'Country Name': 'Wallis and Futuna',
      'Time Zone': 'Pacific/Wallis',
      'GMT Offset': 'UTC +12:00',
    },
    {
      'Country Code': 'EH',
      'Country Name': 'Western Sahara',
      'Time Zone': 'Africa/El_Aaiun',
      'GMT Offset': 'UTC +01:00',
    },
    {
      'Country Code': 'YE',
      'Country Name': 'Yemen',
      'Time Zone': 'Asia/Aden',
      'GMT Offset': 'UTC +03:00',
    },
    {
      'Country Code': 'ZM',
      'Country Name': 'Zambia',
      'Time Zone': 'Africa/Lusaka',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'ZW',
      'Country Name': 'Zimbabwe',
      'Time Zone': 'Africa/Harare',
      'GMT Offset': 'UTC +02:00',
    },
    {
      'Country Code': 'AX',
      'Country Name': 'Åland Islands',
      'Time Zone': 'Europe/Mariehamn',
      'GMT Offset': 'UTC +02:00',
    },
  ],
};
